import styled from "styled-components";
import { DefaultButton } from "Components/Shared/Buttons/DefaultButton";

export const StyledImg = styled.div`
  svg {
    width: 300px;
    height: auto;
    padding: 95px 0;
  }
  @media (max-width: 730px) {
    svg {
      padding: 0;
      width: auto;
      height: 200px;
      margin-bottom: 16px;
      max-width: 100%;
    }
  }
`;

export const StyledButton = styled(DefaultButton)`
  border: 1px solid ${props => props.theme.colors.googleBtnBorder};
  box-shadow: ${props => props.theme.shadow.primary};

  &:hover,
  &:active {
    box-shadow: ${props => props.theme.shadow.primaryHover};
  }
`;

export const StyledButtonText = styled.span`
  font-weight: 500;
  text-transform: none;
  padding: 0 24px;
  color: ${props => props.theme.palette.secondary.main};
`;
